/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var _ = require('underscore');

var tmplTaskAddPresenterModalView = require('../templates/COCAddPresenterModalView.hbs');
require('../styles/COCAddPresenterModalView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplTaskAddPresenterModalView,

  className: 'coc-add-presenter-modal-view',

  ui: {
    addPresenterForm: '.add-presenter-form',
    selectPresenter: '.select-presenter',
    submit: '.submit',
    presenterName: 'input[aria-label="Name"]',
    presenterUsername: 'input[aria-label="Username"]',
    noPresenterSelectedAlert: '#noPresenterSelected',
    userAlreadySelectedAsPresenter: '#userAlreadySelectedAsPresenter',
    eventFollowUpOwnerCheckbox: '#eventFollowUpTaskOwner'
  },

  events: {
    'click @ui.submit': 'onClickSubmit',
    'change @ui.selectPresenter': 'onSelectPresenter'
  },

  onBeforeShow: function() {
    this.ui.eventFollowUpOwnerCheckbox.prop('disabled', this.model.get('hasFollowUpOwner'));
  },

  onRender: function() {
    this.ui.selectPresenter.trigger('change');
  },

  onSelectPresenter: function(e) {
    e.preventDefault;

    var selected = $(e.currentTarget).find('option:selected');
    var name = selected.text();
    var userName = selected.val();

    this.ui.presenterName.val(name);
    this.ui.presenterUsername.val(userName);
  },

  getFormData: function() {
    return Syphon.serialize(this.ui.addPresenterForm);
  },

  validate: function(selectedPresenter) {
    this.ui.noPresenterSelectedAlert.hide();
    this.ui.userAlreadySelectedAsPresenter.hide();

    var existingPresenters = this.model.get('existingPresenters');
    var presenterAlreadyPicked = _.contains(existingPresenters, selectedPresenter.val());

    if (!selectedPresenter.val()) {
      this.ui.noPresenterSelectedAlert.show();
      this.ui.userAlreadySelectedAsPresenter.hide();
      return false;
    } else if (presenterAlreadyPicked) {
      this.ui.noPresenterSelectedAlert.hide();
      this.ui.userAlreadySelectedAsPresenter.show();
      return false;
    } else {
      this.ui.noPresenterSelectedAlert.hide();
      this.ui.userAlreadySelectedAsPresenter.hide();
      return true;
    }
  },

  onClickSubmit: function(e) {
    e.preventDefault();

    var isValid = this.validate(this.ui.selectPresenter);

    if (!isValid) {
      return;
    }

    var self = this;
    this.ui.addPresenterForm
      .parsley()
      .whenValidate()
      .done(function() {
        var formData = self.getFormData();
        var presenter = _.find(self.model.get('cocUsers'), function(cocUser) {
          return cocUser.username === formData.username;
        });
        presenter.eventFollowUpTaskOwner = formData.eventFollowUpTaskOwner;
        self.triggerMethod('modal:close', presenter);
      });
  }
});
